//merge sort modified from the algorithm outlined in the blog post: http://www.stoimen.com/blog/2010/07/02/friday-algorithms-javascript-merge-sort/
//var SortingExample = SortingExample || {};
//SortingExample.Utility = SortingExample.Utility || {};


const Sorter = {

    sortField: '',

    compare: function(a, b) {
        const first = a[this.sortField];
        const next = b[this.sortField];
    
        let comparison = 0;
        if (first > next) {
          comparison = 1;
        } else if (first < next) {
          comparison = -1;
        }
    
        return comparison;
    },

    sort: function (arrayToSort, sortField) {
        this.sortField = sortField;
        if (arrayToSort.length <= 10) 
            return this.insertionSort(arrayToSort);
        else return this.mergeSort(arrayToSort);
    },

    mergeSort: function (arr) {
        if (arr.length < 2)
            return arr;

        var middle = parseInt(arr.length / 2);
        var left = arr.slice(0, middle);
        var right = arr.slice(middle, arr.length);

        return this.merge(this.mergeSort(left), this.mergeSort(right));
    },

    merge: function (left, right) {
        var result = [];

        while (left.length && right.length) {
            if (this.compare(left[0], right[0]) < 1) {
                result.push(left.shift());
            } else {
                result.push(right.shift());
            }
        }

        while (left.length)
            result.push(left.shift());

        while (right.length)
            result.push(right.shift());

        return result;
    },

    insertionSort: function (arrayToSort) {
        var arrLength = arrayToSort.length;
        var value;
        var i;
        var j;
        
        for (i = 0; i < arrLength; i++) {
            value = arrayToSort[i];
            for (j = i - 1; j > -1 && this.compare(arrayToSort[j], value) == 1; j--)
            {
                arrayToSort[j + 1] = arrayToSort[j];
            }
            arrayToSort[j + 1] = value;
        }

        return arrayToSort;
    }
}


export default Sorter;